// Điểm mở rộng của module Khách hàng cho khung ứng dụng (FSD.md §2.1, §3.3): Tạo mới, Tìm nhanh, lớp phủ, thời gian thực.
import { qk, type RealtimeBinding } from '@/shared/api';
import { lazyComponent, type OverlayDef } from '@/shared/lib';
import type { CreateItem, SearchProvider } from '@/widgets/app-shell';
import { phoneLabel, searchCustomers, stageLabel } from '@/entities/customer';

/** Thành phần lớp phủ nạp khi mở (chunk riêng; OverlayHost nạp trước lúc rảnh). */
const CustomerDrawerOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.CustomerDrawerOverlay, 'CustomerDrawerOverlay');
const CustomerFormOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.CustomerFormOverlay, 'CustomerFormOverlay');

/** Mục "Tạo mới" ở thanh trên: mở form khách tại trang hiện tại (phím tắt N). */
export const createItems: CreateItem[] = [{ label: 'Khách hàng', icon: 'userplus', module: 'customers', perm: 'customers.create', to: '.', overlay: ['customerForm', 'new'], shortcut: 'n' }];

/** Tìm nhanh: khách theo tên không dấu / chữ số SĐT (chỉ khớp khách được xem số) — crm lọc theo phạm vi ⇒ mở hồ sơ. */
export const searchProviders: SearchProvider[] = [
  {
    id: 'customers',
    module: 'customers',
    group: 'Khách hàng',
    perm: ['customers.view', 'customers.assign'],
    search: async (q, { signal }) =>
      (await searchCustomers(q, signal)).map((c) => ({
        key: c.id,
        icon: 'users',
        title: c.name,
        sub: `${phoneLabel(c.phoneDisplay)} · ${stageLabel(c.stage)}`,
        overlay: ['customer', c.id] as const,
      })),
  },
];

/** ?customer=<id> (hồ sơ) và ?customerForm=new|<id> (form) — mở từ mọi trang khi module Khách hàng hiển thị. */
export const overlays: OverlayDef[] = [
  { key: 'customer', module: 'customers', layer: 'drawer', component: CustomerDrawerOverlay },
  { key: 'customerForm', module: 'customers', layer: 'modal', component: CustomerFormOverlay },
];

/**
 * crm.customers: gợi ý "khách đã đổi" — tin toàn công ty chỉ mang { count }, tin cho chủ khách / người thao tác mang ids.
 * Làm mới cả tiền tố khách (danh sách, số đếm, hồ sơ đang mở…); giao dịch của khách nằm dưới 'deals' (chủ đề deals).
 */
export const realtime: RealtimeBinding[] = [{ topic: 'crm.customers', module: 'customers', keys: () => [qk.customers.all] }];
